import { render, staticRenderFns } from "./tarihegore.vue?vue&type=template&id=d510b694&"
import script from "./tarihegore.vue?vue&type=script&lang=js&"
export * from "./tarihegore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports